export default __webpack_public_path__ + "media/transfer_window/transfer_completed-1-16355eff.mp4";